import { css } from '@/styled-system/css';

export const dotStyles = css.raw({
  width: '15px',
  height: '15px',
  borderRadius: '15px',
  backgroundColor: 'purple.400',
  float: 'left',
  marginTop: '3px',
  marginRight: '200',
});
